/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import SweepstakesGalleryAlt from '../blocks/SweepstakesGalleryAlt';

export const SweepstakePageAlt = () => {
  return (
    <>
      <SweepstakesGalleryAlt
        desktopVerticalCards
        desktopVerticalHeadingSize="xs"
        hideTabListOnMobile
        openFormOnHashSelect
        stackedContent={[
          {
            heroTitle: 'Fans win with <strong>Xumo</strong>',
            className: 'text-xumoDarkPlum mt-10 type-heading-lg',
          },
          {
            bodyBase: '',
            className: 'type-body max-w-[350px] md:max-w-[500px] mx-auto lg:mx-0 lg:max-w-[800px]',
          },
        ]}
        sweepstakes={[
          {
            logo: {
              src: '/static/images/refresh/2026/xumo-logo-color.png',
              alt: 'Xumo Logo',
            },
            id: 'xumo-nascar-2026-tv-1',
            tabTitle: 'NASCAR® TV',
            headingBold: 'This could be your chance to win a 65” Xumo TV',
            body: '',
            cardUI: {
              variant: 'tv',
              title: {
                thin: 'This could be your chance to win a',
                bold: '65” Xumo TV',
              },
              backgroundImage: {
                src: '/static/images/refresh/2026/tv-bg.webp',
                alt: 'Xumo TV prize image',
              },
              cta: {
                label: 'Enter now',
                variant: 'light',
              },
            },
            startDate: '2026-08-27T21:00:00Z',
            endDate: '2026-08-31T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoTV',
            disclaimer:
              '<p><b>NO PURCHASE NECESSARY; void where prohibited.</b> Open to legal United States residents residing in the fifty (50) United States and Washington, D.C., who are at least eighteen (18) years of age and the age of majority in their state of residence (nineteen (19) in AL and NE; eighteen (18) in all other states) at time of entry. Employees of Comcast Cable Communications Management, LLC are not eligible. See Official Rules at <a href="http://therulespage.com/XumoTV" target="_blank">therulespage.com/XumoTV</a> for complete details. Sweepstakes begins at 12:00 a.m. ET on August 28, 2026, and ends 11:59 p.m. ET on November 10, 2026. Sponsor: Comcast Cable Communications Management, LLC, 1 Comcast Center, Philadelphia, PA 19103. <b>Xumo LLC is not a sponsor or administrator of this Sweepstakes.</b></p>',
          },
          {
            logo: {
              src: '/static/images/refresh/2026/xumo-logo-color.png',
              alt: 'Xumo Logo',
            },
            id: 'xumo-nascar-2026-tv-2',
            tabTitle: 'NASCAR® TV',
            headingBold: 'This could be your chance to win a 65” Xumo TV',
            body: '',
            cardUI: {
              variant: 'tv',
              title: {
                thin: 'This could be your chance to win a',
                bold: '65” Xumo TV',
              },
              backgroundImage: {
                src: '/static/images/refresh/2026/tv-bg.webp',
                alt: 'Xumo TV prize image',
              },
              cta: {
                label: 'Enter now',
                variant: 'light',
              },
            },
            startDate: '2026-10-09T04:00:00Z',
            endDate: '2026-10-13T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoTV',
            disclaimer:
              '<p><b>NO PURCHASE NECESSARY; void where prohibited.</b> Open to legal United States residents residing in the fifty (50) United States and Washington, D.C., who are at least eighteen (18) years of age and the age of majority in their state of residence (nineteen (19) in AL and NE; eighteen (18) in all other states) at time of entry. Employees of Comcast Cable Communications Management, LLC are not eligible. See Official Rules at <a href="http://therulespage.com/XumoTV" target="_blank">therulespage.com/XumoTV</a> for complete details. Sweepstakes begins at 12:00 a.m. ET on August 28, 2026, and ends 11:59 p.m. ET on November 10, 2026. Sponsor: Comcast Cable Communications Management, LLC, 1 Comcast Center, Philadelphia, PA 19103. <b>Xumo LLC is not a sponsor or administrator of this Sweepstakes.</b></p>',
          },
          {
            logo: {
              src: '/static/images/refresh/2026/xumo-logo-color.png',
              alt: 'Xumo Logo',
            },
            id: 'xumo-nascar-2026-tv-3',
            tabTitle: 'NASCAR® TV',
            headingBold: 'This could be your chance to win a 65” Xumo TV',
            body: '',
            cardUI: {
              variant: 'tv',
              title: {
                thin: 'This could be your chance to win a',
                bold: '65” Xumo TV',
              },
              backgroundImage: {
                src: '/static/images/refresh/2026/tv-bg.webp',
                alt: 'Xumo TV prize image',
              },
              cta: {
                label: 'Enter now',
                variant: 'light',
              },
            },
            startDate: '2026-10-23T04:00:00Z',
            endDate: '2026-11-11T04:59:59Z',
            rulesLink: 'http://therulespage.com/XumoTV',
            disclaimer:
              '<p><b>NO PURCHASE NECESSARY; void where prohibited.</b> Open to legal United States residents residing in the fifty (50) United States and Washington, D.C., who are at least eighteen (18) years of age and the age of majority in their state of residence (nineteen (19) in AL and NE; eighteen (18) in all other states) at time of entry. Employees of Comcast Cable Communications Management, LLC are not eligible. See Official Rules at <a href="http://therulespage.com/XumoTV" target="_blank">therulespage.com/XumoTV</a> for complete details. Sweepstakes begins at 12:00 a.m. ET on August 28, 2026, and ends 11:59 p.m. ET on November 10, 2026. Sponsor: Comcast Cable Communications Management, LLC, 1 Comcast Center, Philadelphia, PA 19103. <b>Xumo LLC is not a sponsor or administrator of this Sweepstakes.</b></p>',
          },
          {
            logo: {
              src: '/static/images/refresh/2026/xumo-logo-color.png',
              alt: 'Xumo Logo',
            },
            id: 'xumo-nascar-2026-2',
            tabTitle: 'Bristol',
            headingBold: 'Enter for a chance to win two VIP tickets to NASCAR® in Bristol',
            body: 'September 19, 2026 | Bristol, TN',
            cardUI: {
              variant: 'event',
              title: {
                thin: 'Enter for a chance to',
                bold: 'win two VIP tickets to NASCAR® in Bristol',
              },
              description: 'Includes access to pit roads and garages',
              meta: 'September 19, 2026 | Bristol, TN',
              backgroundImage: {
                src: '/static/images/refresh/2026/nascar/race-bg.png',
                alt: 'NASCAR race cars',
              },
              cta: {
                label: 'Enter now',
                variant: 'light',
              },
            },
            startDate: '2026-08-18T04:00:00Z',
            endDate: '2026-08-27T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoNASCAR',
            successMessage: 'You’re now entered for a chance to win two VIP NASCAR® tickets!',
            disclaimer:
              '<p><b>NO PURCHASE NECESSARY; void where prohibited.</b> Open to legal United States residents residing in the fifty (50) United States and Washington, D.C., who are at least eighteen (18) years of age and the age of majority in their state of residence (nineteen (19) in AL and NE; eighteen (18) in all other states) at time of entry. Employees of Comcast Cable Communications Management, LLC and NASCAR, LLC are not eligible. See Official Rules at <a target="_blank" href="http://therulespage.com/XumoNASCAR">therulespage.com/XumoNASCAR</a> for additional eligibility restrictions and complete details. Sweepstakes begins at 12:00 a.m. ET on August 12, 2026, and ends 11:59 p.m. ET on October 12, 2026. Sponsor: Comcast Cable Communications Management, LLC, 1 Comcast Center, Philadelphia, PA 19103. <b>National Association for Stock Car Auto Racing, LLC and Xumo LLC are not sponsors or administrators of this Sweepstakes.</b></p>',
          },
          {
            logo: {
              src: '/static/images/refresh/2026/xumo-logo-color.png',
              alt: 'Xumo Logo',
            },
            id: 'xumo-nascar-2026-3',
            tabTitle: 'Las Vegas',
            headingBold: 'Enter for a chance to win two VIP tickets to NASCAR® in Las Vegas',
            body: 'October 4, 2026 | Las Vegas, NV',
            cardUI: {
              variant: 'event',
              title: {
                thin: 'Enter for a chance to',
                bold: 'win two VIP tickets to NASCAR® in Las Vegas',
              },
              description: 'Includes access to pit roads and garages',
              meta: 'October 4, 2026 | Las Vegas, NV',
              backgroundImage: {
                src: '/static/images/refresh/2026/nascar/race-bg2.png',
                alt: 'NASCAR race cars',
              },
              cta: {
                label: 'Enter now',
                variant: 'light',
              },
            },
            startDate: '2026-08-27T04:00:00Z',
            endDate: '2026-09-22T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoNASCAR',
            successMessage: 'You’re now entered for a chance to win two VIP NASCAR® tickets!',
            disclaimer:
              '<p><b>NO PURCHASE NECESSARY; void where prohibited.</b> Open to legal United States residents residing in the fifty (50) United States and Washington, D.C., who are at least eighteen (18) years of age and the age of majority in their state of residence (nineteen (19) in AL and NE; eighteen (18) in all other states) at time of entry. Employees of Comcast Cable Communications Management, LLC and NASCAR, LLC are not eligible. See Official Rules at <a target="_blank" href="http://therulespage.com/XumoNASCAR">therulespage.com/XumoNASCAR</a> for additional eligibility restrictions and complete details. Sweepstakes begins at 12:00 a.m. ET on August 12, 2026, and ends 11:59 p.m. ET on October 12, 2026. Sponsor: Comcast Cable Communications Management, LLC, 1 Comcast Center, Philadelphia, PA 19103. <b>National Association for Stock Car Auto Racing, LLC and Xumo LLC are not sponsors or administrators of this Sweepstakes.</b></p>',
          },
          {
            logo: {
              src: '/static/images/refresh/2026/xumo-logo-color.png',
              alt: 'Xumo Logo',
            },
            id: 'xumo-nascar-2026-4',
            tabTitle: 'Talladega',
            headingBold: 'Enter for a chance to win two VIP tickets to NASCAR® in Talladega',
            body: 'October 25, 2026 | Talladega, AL',
            cardUI: {
              variant: 'fullImage',
              logoBelowContent: false,
              title: {
                thin: 'Enter for a chance to',
                bold: 'win two VIP tickets to NASCAR® in Talladega',
              },
              description: 'Includes access to pit roads and garages',
              meta: 'October 25, 2026 | Talladega, AL',
              contentImage: {
                src: '/static/images/refresh/2026/nascar/race-meet.png',
                alt: 'NASCAR race car with Xumo logo in background',
              },
              shallowContentImage: true,
              contentImageAlign: 'topCenter',
              backgroundBlur: {
                enabled: false,
                amountPx: 15,
              },
              backgroundTint: {
                enabled: false,
                color: '#2D1A2A',
                opacity: 1,
              },
              blurHalf: {
                enabled: false,
                side: 'bottom',
              },
              cta: {
                label: 'Enter now',
                variant: 'light',
              },
            },
            startDate: '2026-09-22T04:00:00Z',
            endDate: '2026-10-13T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoNASCAR',
            successMessage: 'You’re now entered for a chance to win two VIP NASCAR® tickets!',
            disclaimer:
              '<p><b>NO PURCHASE NECESSARY; void where prohibited.</b> Open to legal United States residents residing in the fifty (50) United States and Washington, D.C., who are at least eighteen (18) years of age and the age of majority in their state of residence (nineteen (19) in AL and NE; eighteen (18) in all other states) at time of entry. Employees of Comcast Cable Communications Management, LLC and NASCAR, LLC are not eligible. See Official Rules at <a target="_blank" href="http://therulespage.com/XumoNASCAR">therulespage.com/XumoNASCAR</a> for additional eligibility restrictions and complete details. Sweepstakes begins at 12:00 a.m. ET on August 12, 2026, and ends 11:59 p.m. ET on October 12, 2026. Sponsor: Comcast Cable Communications Management, LLC, 1 Comcast Center, Philadelphia, PA 19103. <b>National Association for Stock Car Auto Racing, LLC and Xumo LLC are not sponsors or administrators of this Sweepstakes.</b></p>',
          },
          {
            logo: {
              src: '/static/images/refresh/2026/xumo-logo-white.png',
              alt: 'Xumo Logo',
            },
            id: 'xumo-bravo-2026-1',
            tabTitle: 'Fan Fest',
            headingBold: 'Enter for a chance to win two tickets to Bravo Fan Fest',
            body: 'October 24, 2026 | Charleston, SC',
            cardUI: {
              logoBelowContent: true,
              variant: 'fullImage',
              title: {
                thin: 'Enter for a chance to',
                bold: 'win two tickets to Bravo Fan Fest',
              },
              meta: 'October 24, 2026 | Charleston, SC',
              backgroundImage: {
                src: '/static/images/refresh/2026/fan-fest.png',
                alt: 'Bravo Fan Fest image',
              },
              contentImage: {
                src: '/static/images/refresh/2026/fan-content-swirl.png',
                alt: 'Fan Fest tv image',
              },
              contentImageAlign: 'topCenter',
              backgroundBlur: {
                enabled: true,
                amountPx: 15,
              },
              backgroundTint: {
                enabled: true,
                color: '#37b8c8',
                opacity: 0.75,
              },
              blurHalf: {
                enabled: false,
                side: 'bottom',
              },
              cta: {
                label: 'Enter now',
                variant: 'berry',
              },
            },
            startDate: '2026-08-29T04:00:00Z',
            endDate: '2026-10-02T03:59:59Z',
            rulesLink: 'http://therulespage.com/XumoBravoFanFest',
            successMessage: 'You’re now entered for a chance to win two Fan Fest tickets!',
            disclaimer:
              '<p><b>NO PURCHASE NECESSARY; void where prohibited.</b> Open to legal United States residents residing in the fifty (50) United States and Washington, D.C., who are at least eighteen (18) years of age and the age of majority in their state of residence (nineteen (19) in AL and NE; eighteen (18) in all other states) at time of entry. Employees of Comcast Cable Communications Management, LLC are not eligible. See Official Rules at <a target="_blank" href="http://therulespage.com/XumoBravoFanFest">therulespage.com/XumoBravoFanFest</a> for additional eligibility restrictions and complete details. Sweepstakes begins at 12:00 a.m. ET on September 1, 2026, and ends 11:59 p.m. ET on October 1, 2026. Sponsor: Comcast Cable Communications Management, LLC, 1 Comcast Center, Philadelphia, PA 19103.  Bravo Media and NBCUniversal Media, LLC, are not a sponsor or administrator of this Sweepstakes.</p>',
          },
        ]}
      />
    </>
  );
};
